﻿﻿export interface IUpdateClusterComment {
    clusterId: number;
    comment: string;
}
